export default function (url){
    let head = document.getElementsByTagName('head')[0];
    let script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';

    head.appendChild(script);

    return script;
}